import { render, staticRenderFns } from "./Padrao.vue?vue&type=template&id=3e1647aa&scoped=true"
import script from "./Padrao.vue?vue&type=script&lang=js"
export * from "./Padrao.vue?vue&type=script&lang=js"
import style0 from "./Padrao.vue?vue&type=style&index=0&id=3e1647aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1647aa",
  null
  
)

export default component.exports